import { render, staticRenderFns } from "./CartPendingOrdersReceived.vue?vue&type=template&id=7dc0cf1e"
import script from "./CartPendingOrdersReceived.vue?vue&type=script&lang=js"
export * from "./CartPendingOrdersReceived.vue?vue&type=script&lang=js"
import style0 from "./CartPendingOrdersReceived.vue?vue&type=style&index=0&id=7dc0cf1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports